import React, { useEffect } from "react";
import cx from "classnames";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import styles from "./anonymous.module.scss";
import AuthService from "src/utils/auth.service";
import { logoutUser } from "src/redux/actions/users";
import { useDispatch } from "react-redux";
import _ from "lodash";
import { setChromeExtAlertBannerVisible } from "src/utils/util";

function AnonymousView() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const authenticated = AuthService.isAuthenticated();

  useEffect(() => {
    setChromeExtAlertBannerVisible(true); // set chrome ext alert to true on logout
    const currentPath = location.pathname + location.search;

    switch (currentPath) {
      case "/":
        if (authenticated) {
          navigate("/search");
        } else {
          navigate("/public/login");
          dispatch(logoutUser());
        }
        break;
      case "/logout":
        dispatch(logoutUser());
        navigate("/public/login");
        break;
      default:
        navigate(currentPath);
        break;
    }
  }, []);

  return (
    <div className={styles.container}>
      {!authenticated && <BackgroundBanner />}
      <Outlet />
    </div>
  );
}

const BackgroundBanner: React.FC = () => {
  return (
    <div className={styles.backgroundBanner}>
      <video
        poster={"/images/login/read_the_room.png"}
        autoPlay
        playsInline
        muted
        loop
        className={cx(styles.video)}
      >
      <source src={"/images/login/read_the_room.mp4"} type="video/mp4" />
      </video>
      <div className={styles.overlayContent}>
        <p className={styles.description}>
          Every click, share, and <br /> download tells a story.
        </p>
        <p className={styles.subText}>
          Learn what your prospects <br /> aren't saying with our{" "}
          <a
            href="https://product.paperflite.com/digital-sales-room"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.link}
          >
            Digital <br/>Deal Room.
          </a>
        </p>

        <a
          href="https://product.paperflite.com/digital-sales-room"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.tourButton}
        >
          TOUR THE ROOM
        </a>
      </div>
      <p className={styles.copyRight}>
        © {new Date().getFullYear()} Paperflite
      </p>
    </div>
  );
};

export default AnonymousView;
